import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { CheckUpdateMemberStatusTypes } from '../Types';

const machine = Machines.onCheckUpdateMemberStatus.machine;

export const checkUpdateMemberStatus = (): Promise<CheckUpdateMemberStatusTypes.ICheckUpdateMemberStatusServiceResponse> => {
  return callServiceMachine(machine);
};

export default { checkUpdateMemberStatus };
